var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 76,
    viewBox: "0 0 74 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_396)",
    filter: "url(#filter0_d_893_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3344 41.4536V68H25.4077V43.5268H48.8442V68H50.9176V41.4536H23.3344Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2524 51.2751V68H44.3256V53.3485H45.4314V51.2751H42.2524Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5685 51.2751V53.3485H29.6743V68H31.7475V51.2751H28.5685Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7747 17.0066V39.2751H43.4771V17.0066H30.7747ZM41.4036 37.2018H32.8479V19.0799H41.4036V37.2018Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9279 47.8196V49.8929H67.8234V67.9999H69.8966V47.8196H51.9279Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4327 55.4219V68H64.506V57.4952H65.7501V55.4219H62.4327Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9279 55.4219V57.4952H53.0337V68H55.107V55.4219H51.9279Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2217 31.8872V45.6527H62.6096V31.8872H55.2217ZM60.5362 43.5794H57.2951V33.9605H60.5362V43.5794Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10339 47.8196V67.9999H6.1766V49.8929H22.0721V47.8196H4.10339Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38818 55.4219V57.4952H9.35572V68H11.4291V55.4219H8.38818Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 55.4219V68H21.1046V57.4952H22.0721V55.4219H19.0312Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6424 31.8872V45.6527H19.0304V31.8872H11.6424ZM16.957 43.5794H13.7157V33.9605H16.957V43.5794Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2438 44.7781H36.1705V46.8514H38.2438V44.7781Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2438 47.8191H36.1705V59.2914H38.2438V47.8191Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8206 5.52417H31.7473V7.59751H33.8206V5.52417Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2438 5.52417H36.1705V7.59751H38.2438V5.52417Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3904 5.52417H40.317V7.59751H42.3904V5.52417Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7917 5.52407V0H25.4602V5.52407H23.316V7.59741H25.4602V12.7025H33.6238L37.1259 15.0377L40.6282 12.7025H48.7917V7.59727H50.8222V5.52407H48.7917ZM46.7183 10.6291H40.0002L37.1258 12.5456L34.2516 10.6291H27.5335V2.07334H46.7183V10.6291Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0722 7.59737V5.52417H14.7463V25.2559L13.412 23.9212L11.9459 25.3875L15.7296 29.3092L19.6514 25.3873L18.3233 23.9214L16.8197 25.4251V7.59737H22.0722Z",
    fill: "#2B3478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7015 24.1977L59.2537 25.6458V5.52417H51.9279V7.59737H57.1803V25.588L55.7902 24.1976L54.3239 25.6639L58.2459 29.5857L62.1676 25.6637L60.7015 24.1977Z",
    fill: "#2B3478"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_893_396",
    x: -1,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_893_396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_893_396",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/OrdersIcon.c86e769b66bf5b267591edd6d8d72d72.svg";
export { ForwardRef as ReactComponent };